import { createApp } from "vue/dist/vue.esm-bundler.js"
import { useVuelidate } from "@vuelidate/core";
import { required, email, sameAs, requiredIf, minLength, helpers } from "@vuelidate/validators";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Select2 from '../components/vue/select2.vue';
import recaptcha from '../components/recaptcha';

createApp({
    setup() {
        return { v$: useVuelidate() }
    },
    components: {
        Select2,
        VueDatePicker,
        recaptcha
    },
    computed: {
        submitEnabled() {
            return this.recaptchaPassed;
        }
    },
    data() {
        return {
            recaptchaPassed: false,
            facility: [],
            date: null,
            tenant: '',
            sponsor: '',
            phone: '',
            email: '',
            verifedEmail: '',
            personnel: [
                {
                    name: '',
                    company: ''
                }
            ]
        }
    },
    methods: {
        async validatePage() {
            var isValid = await this.v$.$validate();

            return isValid;
        },
        async submit() {

            var isValid = await this.validatePage();
            

            if (isValid) {
                $('#terminalAccessForm').submit();
            }

        },
        async addPerson() {

            this.personnel.push({ name: '', company: '' });

        },
        fieldErrors(index, fieldName) {
            if (!this.v$.personnel.$dirty) {
                return []
            }

            return this.v$.personnel.$each.$response.$errors[index]?.[fieldName] || []
        },

        hasError(index, fieldName) {
            return this.fieldErrors(index, fieldName).length > 0
        },
        removePerson(index) {
            this.personnel.splice(index, 1);
        },
        recaptchaCallback(newState) {
            this.recaptchaPassed = !!newState;
        }
    },
    validations() {
        return {
            facility: { required },
            date: { required },
            tenant: { required },
            sponsor: { required },
            phone: { required },
            email: { required, email },
            verifedEmail: { required, email, sameAsEmail: sameAs(this.email) },
            personnel: {
                minLength: minLength(1),
                $each: helpers.forEach({
                    name: {
                        required: helpers.withMessage('Name is required', required)
                    },
                    company: {
                        required: helpers.withMessage('Company is required', required)
                    }
                })
            },
        }
    }
}).mount('#terminalAccessFormApp');
